// extracted by mini-css-extract-plugin
export default {"Tooltip":"NoMassHourTooltip-module--Tooltip--OD+Ia"};